import { Common, Hardfork } from '@exodus/ethereumjs/common'
import { FeeMarketEIP1559Transaction, Transaction } from '@exodus/ethereumjs/tx'

export default function createEthereumJsTx(unsignedTx) {
  const {
    txData: { chainId, ...txData },
    txMeta: { eip1559Enabled },
  } = unsignedTx
  const { gasPrice, tipGasPrice } = txData

  /*
    EIP1559 is not supported by all ethereum-like assets.
    e.g BSC does not support EIP1559 at the moment, prevent building an EIP1559 transaction
    if `tipGasPrice` or `maxPriorityFeePerGas` is set.
  */
  const isEip1559Tx = !!(unsignedTx.txData.tipGasPrice || unsignedTx.txData.maxPriorityFeePerGas)
  if (eip1559Enabled && isEip1559Tx) {
    return FeeMarketEIP1559Transaction.fromTxData(
      {
        maxFeePerGas: gasPrice,
        maxPriorityFeePerGas: tipGasPrice,
        // `maxPriorityFeePerGas`, `maxFeePerGas` set in `txData` below take precedence over ^.
        ...txData,
      },
      {
        common: Common.custom(
          {
            chainId,
          },
          { hardfork: Hardfork.London }
        ),
      }
    )
  }

  // Legacy tx
  return Transaction.fromTxData(txData, { common: Common.custom({ chainId }) })
}
